/** @jsxImportSource @emotion/react */
import { useState, useEffect,useContext } from 'react';
import config from '../../config';
import PageLayout from '../Layout/PageLayout';
import axios from '../../Helper/Axios/interceptor';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Il8nContext } from '../../Helper/i18n';

function Scrutiny(props) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [name, setName] = useState("")
    const localeText = useContext(Il8nContext)


    useEffect(() => {
        getKYCData()
    }, [])

    const getKYCData = () => {
        axios.get(process.env.REACT_APP_API_URL + config.kycData)
            .then(dataResp => {
                if (dataResp.data.success) {
                    let data = dataResp.data.success[0]
                    setName((data.clientFirstName ? data.clientFirstName : " ") + " " + (data.clientMiddleName ? data.clientMiddleName : " ") + " " + (data.clientLastName ? data.clientLastName : " "))
                } else {
                    throw new Error(dataResp.data.error)
                }
            })
            .catch((err) => {
                console.log(err.message)
            })
    }

    return (
        <PageLayout hideSidebarGrid={isSmallScreen ? true : false} calculateHeight={isSmallScreen ? true : false}>
            <ElevatedGrid customCss={{ height: "inherit", position: "relative" }}>
                <Grid container direction={"column"} justifyContent="center" alignItems="center" css={{ height: "100%" }}>
                    <Grid item>
                        <Typography variant={"h4"} fontWeight={"bold"} color="#24b7cc" align="center">
                            {localeText?.ScrutinyCongratulations}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant={"h4"} fontWeight={"bold"} align="center">
                            {name}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant={"h6"} align="center">
                            {localeText?.Scrutinysubmitted}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <img src="images/icon_congratulations.svg" alt="congrats_Account_Opened" css={{ height: "100%", width: "100%" }} />
                    </Grid>
                </Grid>
                <Grid container justifyContent={"end"} alignItems={"end"} css={{ position: "absolute", bottom: 0, right: 0, marginBottom: "20px" }}>
                    <Grid item>
                        <Typography align="center" variant={"h6"} css={{ paddingBottom: "10px" }}>
                            {localeText?.Scrutinyunder}
                            <b>{localeText?.Scrutiny}</b>
                            {localeText?.Scrutinyprocess}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <img src="images/icon_scrutiny-under-process.svg" alt="under_proces" css={{ height: "100%", width: "100%" }} />
                    </Grid>
                </Grid>
            </ElevatedGrid>
        </PageLayout>
    );
}

export default Scrutiny;
